import { Box, Grid, Typography, useTheme, SvgIcon } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactComponent as AddCircleSVG } from 'assets/svg/new-icons/circleicon.svg'

// import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Instruction } from './types'
interface Props {
  instructions: Instruction[]
  titleList: boolean
}
const ListInstructions = (props: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { instructions, titleList } = props

  const CARD_WIDTH = 253

  return (
    <>
      {titleList === true ? (
        <>
          <Typography
            color="black"
            align="center"
            fontWeight={700}
            fontSize="20px"
            lineHeight="23px"
            sx={{ mt: '75px', font: 'Roboto' }}
          >
            {t('listInstructions.noListsYet')}
          </Typography>
          <Typography
            color="black"
            align="center"
            fontWeight={700}
            fontSize="20px"
            lineHeight="23px"
            sx={{ mb: '159px' }}
          >
            {t('listInstructions.createOneSteps')}
          </Typography>{' '}
        </>
      ) : (
        <Typography
          color="black"
          align="center"
          fontWeight={700}
          fontSize="20px"
          sx={{ mt: '55px' }}
        >
          {t('listInstructions.noPropertiesHere')}
        </Typography>
      )}
      <Box
        sx={{
          mt: '85px',
          display: 'grid',
          gridTemplateColumns: `repeat(${instructions?.length},  ${CARD_WIDTH}px)`,
          columnGap: '14px',
          rowGap: '40px',
          justifyContent: 'center',
          alignitems: 'center',
          [theme.breakpoints.down('lg')]: {
            gridTemplateColumns: `repeat(2, ${CARD_WIDTH}px)`,
          },
          [theme.breakpoints.down('md')]: {
            gridTemplateColumns: `repeat(1, ${CARD_WIDTH}px)`,
          },
        }}
      >
        {instructions?.map((ins) => (
          <Box
            key={ins.number}
            sx={{
              bgcolor: 'white.main',
              maxWidth: CARD_WIDTH,
              width: '100%',
              height: '100%',
              minHeight: '347px',
              borderRadius: '20px',
              boxShadow: '8px 8px 20px rgba(9, 9, 9, 0.25)',
              border: '1px',
              borderColor: 'transparent',
              p: '17px',
            }}
          >
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="space-between"
              height="100%"
            >
              <Grid>
                <Typography
                  fontWeight={900}
                  fontSize="55px"
                  align="center"
                  fontFamily="Roboto"
                  lineHeight="63px"
                  sx={{
                    color: 'primary.main',
                    textShadow: '4px 4px #000000',
                    position: 'relative',
                    top: '-60px',
                  }}
                >
                  {ins.number}
                </Typography>
              </Grid>
              <Grid display="flex" justifyContent="space-evenly">
                <Typography
                  align="center"
                  fontWeight={900}
                  lineHeight="23px"
                  fontSize="20px"
                  sx={{
                    whiteSpace: 'pre-line',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {ins.text}
                  {ins.number === 2 ? (
                    <SvgIcon
                      component={AddCircleSVG}
                      inheritViewBox
                      sx={{
                        color: 'primary.main',
                        height: '42.5px',
                        width: '42.5px',
                      }}
                    />
                  ) : null}
                </Typography>
              </Grid>
              <Grid>
                <Box
                  component="img"
                  src={ins.icon}
                  justifySelf="end"
                  alignSelf="end"
                ></Box>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    </>
  )
}

export default ListInstructions
